import { attributeName } from 'app/utils/i18n_helpers';

export default function (...args) {
  return attributeName(...args);
}
